import { InfoAlert } from '@procurify/ui'
import styled from 'styled-components'

export const NoticeBannerStyled = styled(InfoAlert)`
  flex-shrink: 0;
  font-size: ${(props) => props.theme.typography.pxToRem(13)};
  line-height: 1.5;
  text-align: left;
`

export const NoticeBannerIconStyled = styled.span`
  color: ${(props) => props.theme.colors.alert.info.icon};
  line-height: 1;
`
